<script>
export default {
  name: "BirthdateMissingDialog",
  props: {
    idBooking: {type: Number, required: true},
    guests: {type: Array, required: true}
  },
  expose: ['open', 'close'],
  data() {
    return {
      show: false,
      prestaGuests: []
    }
  },
  methods: {
    open() {
      this.prestaGuests = this.guests.filter(g => g.ageClassType == "Child" && g.birthDate == null)
      this.show = true
    },
    close() {
      this.show = false
    }
  }
}
</script>

<template>
  <smart-dialog
      v-model="show"
      max-width="700"
      title="Action impossible"
  >
    <div class=" pa-4 ma-4 ">
      <span class="red--text">
      Au moins un des enfants n'a pas de date de naissance:
        </span>
      <div class="d-flex flex-column">
      <div v-for="(g,ind) in this.prestaGuests" :key="ind" class="d-flex flex-column ml-auto right float-right">
          {{ g.firstName }}
          {{ g.lastName }} -
          {{ g.age }} ans
      </div>
        </div>
    </div>
    <v-card-actions class="actions-btn">
      <v-spacer/>
      <v-btn @click="close()">OK</v-btn>
    </v-card-actions>
  </smart-dialog>
</template>

<style scoped>

</style>